// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"455":"bc179656","513":"e2d772be","857":"0801bba8","977":"36b2db4e"}[chunkId] + ".chunk.js";
};